import * as React from "react";
import { connect } from "react-redux";

import { IRecurrence } from "../../classes/recurrencePattern";
import { IState } from "../../classes/state";
import { IText } from "../../classes/text";
import { IText_AddEditEvent } from "../../classes/text_AddEditEvent";

import { RecurrenceModal } from "./RecurrenceModal";

import * as recurrenceActions from "../../actions/recurrenceActions";

export interface IRecurrenceModalContainerProps {
  addEditText: IText_AddEditEvent;
  currentStartDate: Date; // The date currently selected in the Start Date field of the event edit screen.
  dateOfFirstEventInRecurrence: Date;
  displayModal: boolean;
  firstDayOfWeek: string;
  isFromTwoWayCalendar: boolean;
  isTwoWayCalendarEvent: boolean;
  numAjaxCallsInProgress: number;
  onCloseModal: () => void;
  onUpdateRecurrence: (recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string) => void;
  portletInstanceId: number;
  recurrencePattern: IRecurrence;
  text: IText;
  userDateFormat: string;
}

export const RecurrenceModalContainer: React.SFC<IRecurrenceModalContainerProps> = (props) => {
  const isLoading = props.numAjaxCallsInProgress > 0;
  return (
    <RecurrenceModal
      addEditText={props.addEditText}
      currentStartDate={props.currentStartDate}
      dateOfFirstEventInRecurrence={props.dateOfFirstEventInRecurrence}
      displayModal={props.displayModal}
      firstDayOfWeek={props.firstDayOfWeek}
      isLoading={isLoading}
      isFromTwoWayCalendar={props.isFromTwoWayCalendar}
      isTwoWayCalendarEvent={props.isTwoWayCalendarEvent}
      onCloseModal={props.onCloseModal}
      onUpdateRecurrence={props.onUpdateRecurrence}
      portletInstanceId={props.portletInstanceId}
      recurrencePattern={props.recurrencePattern}
      text={props.text}
      userDateFormat={props.userDateFormat}
    />
  );
};

const mapStateToProps = (state: IState, ownProps: IRecurrenceModalContainerProps) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.

const isTwoWayCalendarEvent = state.currentEvent ? state.currentEvent.isTwoWay : null;

return {
    addEditText: state.addOrEditEvent.addEditText,
    currentStartDate: state.addOrEditEvent.currentStartDate,
    dateOfFirstEventInRecurrence: state.addOrEditEvent.dateOfFirstEventInRecurrence,
    displayModal: state.recurrenceSettings.openRecurrencePatternModal,
    firstDayOfWeek: state.calendarSettings.firstDayOfWeek,
    isFromTwoWayCalendar: state.calendarSettings.isTwoWayCalendar,
    isTwoWayCalendarEvent,
    numAjaxCallsInProgress: state.numAjaxCallsInProgress,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    recurrencePattern: state.recurrenceSettings.updatedRecurrencePattern,
    text: state.text,
    userDateFormat: state.calendarSettings.userDateFormat,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCloseModal: (): void => {
      dispatch(recurrenceActions.setOpenRecurrenceModal(false));
    },
    onUpdateRecurrence: (recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string): void => {
      dispatch(recurrenceActions.loadUpdatedRecurrencePattern(recurrence, dateOfFirstEventInRecurrence, firstDayOfWeek));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RecurrenceModalContainer);
